import { BatchItem, BatchPackagingItem } from "shared/api";

export const extractOrderIds = (orders: BatchItem["orders"]): number[] => {
  if (!Array.isArray(orders)) return [];
  return orders.map((o) => o.order.id);
};

export const extractPackagingId = (
  pkg: BatchPackagingItem | number
): number => {
  if (typeof pkg === "number") return pkg;
  return pkg.packaging.id;
};

export const extractPackagingIds = (
  packagings: BatchItem["packagings"]
): number[] => {
  if (!Array.isArray(packagings)) return [];
  return packagings.map(extractPackagingId);
};

export const formatOrdersForDisplay = (batch: BatchItem): string => {
  if (batch.order_codes?.length) {
    return batch.order_codes.map((code) => `Order - ${code}`).join(", ");
  }

  if (!Array.isArray(batch.orders) || batch.orders.length === 0) {
    return "-";
  }

  const orderLabels = batch.orders
    .map((o) => o.order.order_code || o.order.id)
    .map((code) => `Order - ${code}`);

  return orderLabels.join(", ");
};

export const extractOrderIdsForReport = (batch: BatchItem): number[] => {
  if (!Array.isArray(batch.orders)) return [];
  return batch.orders.map((o) => o.id);
};
